/** YYYY-MM-DD in local time (avoids UTC-shift bugs from toISOString()). */
export function toIsoDate(date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

/** e.g. "July 9, 2026" */
export function formatDateLabel(date) {
  return date.toLocaleDateString('en-IN', { month: 'long', day: 'numeric', year: 'numeric' })
}

/** True when `hhmm` on the given date has already passed (invalid input → false). */
export function isPastTime(date, hhmm) {
  if (!date || !hhmm) return false
  const [h, m = 0] = hhmm.split(':').map(Number)
  const slotStart = new Date(date)
  slotStart.setHours(h, m, 0, 0)
  return slotStart.getTime() <= Date.now()
}

/** "HH:mm" (24-hour, as the API returns/expects) → "7:00 AM" for display. */
export function formatTimeLabel(hhmm) {
  if (!hhmm) return ''
  const [hStr, mStr = '0'] = hhmm.split(':')
  const h = Number(hStr)
  if (!Number.isFinite(h)) return hhmm
  const period = h >= 12 ? 'PM' : 'AM'
  const hour12 = h % 12 === 0 ? 12 : h % 12
  return `${hour12}:${mStr.padStart(2, '0')} ${period}`
}
